<div class="address-popover">
	<b class="ion-no-margin font-12">{{ 'address_popover.text.' + environment.customerGroup | translate }}</b>
	<ion-row class="ion-justify-content-center ion-margin-top">
		<ion-chip (click)="dismiss()" class="chip category" tappable>{{ 'address_popover.no' | translate }}</ion-chip>
		<ion-chip (click)="change()" class="chip category selected" tappable>{{ 'address_popover.yes' | translate }} </ion-chip>
	</ion-row>
</div>
